<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        size="lg"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > Satelite Name </label>
             <CRow >
              <CCol >
              <b-input
                v-model="form.name"
                placeholder="Satelite Name"
                id="feedback-user"
                class="mb-1"
                :class="errors.name ? 'is-invalid' : ''"
              >
              </b-input>
              <b-form-invalid-feedback >
              Your satelite name must be filled
              (example: IFGF Surabaya)
              </b-form-invalid-feedback> 
              </CCol>
            </CRow>
            <label class="mt-2"> Location </label>
             <CRow >
               <CCol>
              <b-input
                v-model="form.location"
                placeholder="Location"
                id="feedback-user"
                class="mb-1"
                :class="errors.location ? 'is-invalid' : ''"
              >
              </b-input>
              <b-form-invalid-feedback >
                Your location must be filled
              </b-form-invalid-feedback> 
               </CCol>
            </CRow> 
            <label class="mt-2"> Coordinates </label>
             <CRow >
               <CCol>
              <b-input v-model="form.coordinates" placeholder='Coordinates' id="feedback-user" class="mb-1"> </b-input>
               </CCol>
            </CRow>  
            <label class="mt-2"> Address </label>
             <CRow >
               <CCol>
              <b-input v-model="form.address1" placeholder='Address 1' class="mb-1"> </b-input>
              <b-input v-model="form.address2" placeholder='Address 2' class="mt-2"> </b-input>
               </CCol>
            </CRow>  
            <label class="mt-2"> City </label>
             <CRow >
               <CCol>
              <b-input v-model="form.city" placeholder='City' class="mb-1"> </b-input>
               </CCol>
            </CRow>         
            <label class="mt-2"> State </label>
             <CRow >
               <CCol>
              <b-input v-model="form.state" placeholder='State' class="mb-1"> </b-input>
               </CCol>
            </CRow> 
            <label class="mt-2"> Country </label>
             <CRow >
               <CCol>
              <b-input v-model="form.country" placeholder='Country' class="mb-1"> </b-input>
               </CCol>
            </CRow>  
            <label class="mt-2"> Zipcode </label>
             <CRow >
               <CCol>
              <b-input v-model="form.zipcode" placeholder='Zipcode' class="mb-1"> </b-input>
               </CCol>
            </CRow>     
            <label class="mt-2"> Phone </label>
             <CRow >
               <CCol>
              <b-input v-model="form.phone" placeholder='Phone' class="mb-1"> </b-input>
               </CCol>
            </CRow>     
            </CCol> 
          </CRow>
          <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)"  variant="outline" color="info">Edit</CButton>
      </template>
    </CModal>
    
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import satelite from '@/services/satelitechurch'

export default {
name: 'satelitemodal',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      errors: {},
      errors_from_backend: [],
      form:{
        id: '',
        name: '',
        location:'',
        coordinates:'',
        address1:'',
        address2:'',
        city:'',
        state:'',
        country:'',
        zipcode:'',
        phone:''
      },
      loading: false,
    }
  },
  computed: {
      validationName() {
        return this.form.name.length > 0 
      },
       validationLocation() {
        return this.form.location.length > 0
      },
      
    },
  mounted(){
    
  },
  created () {
    var self = this;

    EventBus.$on('OPEN_MODAL_SATELITE', (params) => {
      if(params.data){
        satelite.getSateliteChurchbyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = res.data.id;
          self.form.name = res.data.name;
          self.form.location = res.data.location;
          self.form.coordinates = res.data.coordinates;
          self.form.address1 = res.data.address1;
          self.form.address2 = res.data.adddres2;
          self.form.city = res.data.city;
          self.form.state = res.data.state;
          self.form.country = res.data.country;
          self.form.zipcode = res.data.zipcode;
          self.form.phone = res.data.phone;
         
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.name = "";
        self.form.location = "";
        self.form.coordinates = "";
        self.form.address1 = "";
        self.form.address2 = "";
        self.form.city = "";
        self.form.state = "";
        self.form.country = "";
        self.form.zipcode = "";
        self.form.phone = "";
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      this.loading = true;
      if (this.check_form()) {
      satelite.createSateliteChurch(this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false;
      }).catch((err) => {
          this.loading = false;
          alert(err.response.data.message);
          //alert(JSON.stringify(err.response.data.errors));
          if (err.response.data.errors != null) {
              this.errors_from_backend = err.response.data.errors;
              console.log(JSON.stringify(err.response.data.errors));
          }
        });
      } else {
        this.loading = false;
      }
    },
    update(id){
      this.show = false;
      satelite.updateSateliteChurch(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    check_form: function(e) {
         this.errors = {};
         if (!this.form.name) {
            this.errors["name"] = "1";
         }
         if (!this.form.location) {
            this.errors["location"] = "1";
         }

         if (
            this.form.name &&
            this.form.location
         ) {
            return true;
         } else {
            return false;
         }
      },
  }
}
</script>

<style>

</style>